import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
import PlaceBeacon from './views/PlaceBeacon.vue'
import BeaconSingle from './views/BeaconSingle.vue'
import Map from './views/Map.vue'
import Settings from './views/Settings.vue'

import Login from './views/Login.vue'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        public: true,
        onlyWhenLoggedOut: true
      }
    },
    {
      path: '/place-beacon',
      name: 'PlaceBeacon',
      component: PlaceBeacon
    },
    {
      path: '/beacon/:index',
      name: 'Beacon-Single',
      component: BeaconSingle
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/map',
      name: 'map',
      component: Map
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedInState = localStorage.getItem('isLogged')
  const loggedIn = loggedInState === null ? false : JSON.parse(loggedInState)

  if (!isPublic && !loggedIn) {
    return next({
      path: '/login',
      query: { redirect: to.fullPath }
      // Store the full path to redirect the user to after login
    })
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn === true && onlyWhenLoggedOut) {
    return next('/')
  }

  next()
})

export default router
